<template>
  <div class="invest-dark py-3">
    <div class="container">
      <div class="px-4 my-5 text-center">
        <h1 class="fs-3 text-uppercase mb-4">
          <strong>We'd be happy to</strong> Respond to your Questions
        </h1>
        <div class="col-lg-6 mx-auto">
          <div class="d-flex justify-content-center flex-lg-row flex-column">
            <button class="invest-button me-lg-2 mb-lg-0 mb-4" @click="onModalOpen('investor')">
              Apply to invest
            </button>
            <button class="invest-button-outline" @click="onModalOpen('general')">
              More info
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onModalOpen: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
